<template>
    <ValidationProvider
      :mode="validationMode"
      :name="label || name || 'unknown'"
      :rules="rules"
      :vid="id"
      v-slot="{ validated, valid, errors }"
      slim
    >
        <rkm-form-group
            :invalid-feedback="errors[0]"
            :state="rules ? (validated ? valid : null) : null"
            :class="{ 'placeholder-label': label === false }"
            :disabled="disabled"
        >
            <label :class="{'no-selection-text': noSelection}" v-if="label" :for="id">
                <slot name="label-leading" />
                    {{ label + (rules && rules.required ? ' *' : '') }}
                <slot name="label-trailing" />
            </label>

            <rkm-input-group
                :append="append"
                :large="groupLarge"
                :prepend="prepend"
                :small="groupSmall"
            >
                <template v-if="!prepend && $slots.prepend" v-slot:prepend>
                    <slot name="prepend" />
                </template>

                <div class="custom-select" :class="{ 'disabled': disabled, 'no-selection': noSelection }" @click.stop="toggleDropdown" ref="dropdown">
                    <div class="selected-items">
                        <div v-if="selectedItems.length === 0">
                            <span>{{ selectedText }}</span>
                        </div>
                        <div v-else>
                            <span>{{ selectedText }}</span>
                        </div>
                    </div>

                    <ul v-show="dropdownVisible" class="dropdown" ref="list">
                        <li v-if="allowSearch" class="search-item" @click.prevent.stop>
                            <input
                                v-model="searchInput"
                                @click.prevent.stop
                                type="text"
                                class="form-control search-input"
                            />
                        </li>
                        <li v-for="(option, index) in optionsWithAll" :key="index" @click="toggleItem($event, option)">
                            <input type="checkbox" :checked="isSelected(option)" :disabled="isDisabled(option)">
                            {{ getOptionName(option) }}
                        </li>
                    </ul>
                </div>

                <template v-if="!append && $slots.append" v-slot:append>
                    <slot name="append" />
                </template>
            </rkm-input-group>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
    components: {
        ValidationProvider
    },
    data() {
        return {
            id: '',
            rules: null,
            searchInput: '',
            dropdownVisible: false,
            selectedItems: ['Todos'],
            previousSelectedItems: [],
        };
    },
    computed: {
        optionsWithAll() {
            if (this.options.length === 0) {
                return [{ [this.optionNameKey]: 'Nenhum', all: true }];
            }

            if (this.allowSearch) {
                return this.searchInput !== null && this.searchInput.trim() !== ''
                    ? [...this.filteredOptions]
                    : [{ [this.optionNameKey]: 'Todos', all: true }, ...this.filteredOptions];
            }

            return [{ [this.optionNameKey]: 'Todos', all: true }, ...this.options];
        },
        filteredOptions() {

            return this.options.filter(option =>
                option[this.optionNameKey].toLowerCase().includes(this.searchInput.toLowerCase())
            );
        },
        selectedText() {
            if (this.selectedItems.length === 0) {
                return this.none ? 'Nenhum' : 'Selecione ao menos um item';
            } else if (this.selectedItems.length === 1 && this.selectedItems[0] === 'Todos') {
                return 'Todos';
            } else if (this.selectedItems.length === this.options.length) {
                return 'Todos';
            } else {
                let text = this.optionTextSelecteds;
                if (this.selectedItems.length > 1) {
                    text = text.split(' ').map(word => {
                        word = word.trim();
                        if (word.toLowerCase().endsWith('m')) {
                            return word.slice(0, -1) + 'ns';
                        }
                        return word + 's';
                    }).join(' ');
                }
                return `${this.selectedItems.length} ${text}`;
            }
        },
        noSelection() {
            if (this.mandatory === true) {

                return this.selectedItems.length === 0;
            } else {

                return false;
            }
        },
    },
    methods: {
        toggleDropdown() {
            if (this.mandatory === true && this.selectedItems.length === 0 && this.dropdownVisible === true) {
                return;
            }

            if (!this.dropdownVisible) {
                this.previousSelectedItems = [...this.selectedItems];
            }

            this.dropdownVisible = !this.dropdownVisible;

            if (this.dropdownVisible) {
                document.body.addEventListener('click', this.bodyClick);
            } else {
                this.checkAndEmitChanges();
                document.body.removeEventListener('click', this.bodyClick);
            }
        },
        checkAndEmitChanges() {
            const hasChanged = JSON.stringify(this.selectedItems) !== JSON.stringify(this.previousSelectedItems);
            if (!hasChanged) {
                this.selectedItems = [...this.previousSelectedItems];
                return;
            }
            this.$emit('update:dropdownClosed', true);
        },
        bodyClick(event) {
            if (this.mandatory === true && this.selectedItems.length === 0) {
                return;
            }

            if (!this.$refs.list.contains(event.target)) {
                this.dropdownVisible = false;
                this.checkAndEmitChanges();
                document.body.removeEventListener('click', this.bodyClick);
            }
        },
        handleWindowClick(event) {

            if (this.mandatory === true && this.selectedItems.length === 0) {

                return;
            }

            const clickedInsideDropdown = this.$refs.dropdown.contains(event.target);
            if (!clickedInsideDropdown) {

                    this.dropdownVisible = false;
            }
        },
        toggleItem(event, item) {

            event.stopPropagation();
            if (item.all) {

                if (this.isSelected(item)) {

                    this.selectedItems = [];
                } else {

                    this.selectedItems = this.options.map(option => option[this.valueField]);
                }
            } else {

                const index = this.selectedItems.indexOf(item[this.valueField]);
                if (index === -1) {

                    this.selectedItems.push(item[this.valueField]);
                } else {

                    this.selectedItems.splice(index, 1);
                }
            }

            this.$emit('input', this.selectedItems);
        },
        handleClickOutside(event) {

            if (this.mandatory === true && this.selectedItems.length === 0) {

                    return;
            }

            if (this.dropdownVisible && event.target !== this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {

                this.dropdownVisible = false;
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        isSelected(item) {

            return item.all ? this.selectedItems.length === this.options.length : this.selectedItems.includes(item[this.valueField]);
        },
        isDisabled(item) {

            return item.all
                ? false
                : (this.selectLimit !== null && this.selectedItems.length >= this.selectLimit) && !this.isSelected(item);
        },
        filterOptions() {

            this.$nextTick(() => {
                this.dropdownVisible = true;
            });
        },
        getOptionName(option) {

            return option[this.optionNameKey];
        }
    },
    props: {
        allowSearch: { type: Boolean, default: false },
        append: { type: String, default: null },
        disabled: { type: Boolean },
        groupLarge: { type: Boolean, default: false },
        groupSmall: { type: Boolean, default: false },
        label: { type: [String, Boolean], default: '' },
        large: { type: Boolean, default: false },
        loadAllAutomatically: { type: Boolean, default: true },
        mandatory: { type: Boolean, default: false },
        name: { type: String },
        optionNameKey: { type: String, default: 'nome' },
        optionTextSelecteds: { type: String, default: 'selecionados' },
        options: { type: [Array, Object], default: () => [] },
        prepend: { type: String, default: null },
        selectLimit: { type: Number, default: 3 },
        small: { type: Boolean, default: false },
        state: { type: Boolean, default: null },
        validationMode: { type: String, default: 'lazy' },
        validations: { type: Object, default: null },
        value: { type: [Array, Boolean, Number, Object, String] },
        valueField: { type: String, default: 'value' },
        none: { type: Boolean, default: false },
        requiredValue: { type: Boolean, default: false },
    },
    watch: {
        options: {
            handler(newOptions) {

                if (!this.loadAllAutomatically) return

                if (this.optionsWithAll.some(option => option.all)) {

                    this.selectedItems = this.optionsWithAll
                        .filter(option => !option.all)
                        .map(option => option[this.valueField]);
                } else {

                    this.selectedItems = newOptions.map(option => option[this.valueField]);
                }
            },
            deep: true
        },
        value: {
            handler(value) {

                this.selectedItems = value;
            },
            deep: true
        },
        selectedItems: {
            handler(newSelectedItems) {

                this.$emit('input', newSelectedItems);
            },
            deep: true
        },
        dropdownVisible(visible) {
            if (!visible) {
                this.searchInput = ''
            }
        }
    },
    created() {

        if (this.optionsWithAll.some(option => option.all)) {

            this.optionsWithAll
                .filter(option => !option.all)
                .forEach(option => {
                    this.selectedItems.push(option[this.valueField]);
                });
        } else {

            this.options.forEach(option => {
                this.selectedItems.push(option[this.valueField]);
            });
        }

        this.id = this.uniqueId(
            (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')
        );

        this.rules = this.disabled ? null : this.validations;

        if (this.value) {

            this.selectedItems = this.value;
        }

        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {

        document.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('click', this.handleWindowClick);
    },
};
</script>

<style scoped>
    .custom-select {
        align-items: center;
        display: flex;
        position: relative;
        width: 100%;
    }
    .custom-select.disabled {
        background-color: #e9ecef;
        color: #6c757d;
        opacity: 0.5;
        pointer-events: none;
    }
    .selected-items {
        display: flex;
        flex-wrap: wrap;
    }
    .selected-item {
        background-color: #f0f0f0;
        border-radius: 3px;
        margin-bottom: 5px;
        margin-right: 5px;
        padding: 2px 5px;
    }
    .dropdown {
        background-color: #fff;
        border: 1px solid #ccc;
        left: 0;
        list-style: none;
        margin: 0;
        max-height: 200px;
        overflow-y: auto;
        padding: 0;
        position: absolute;
        top: 100%;
        width: 100%;
        z-index: 1000;
    }
    .dropdown li {
        cursor: pointer;
        padding: 5px;
    }
    .dropdown li:hover {
        background-color: #f0f0f0;
    }
    .no-selection {
        border: 1px 1px 0px 1px;
        border-style: solid;
        border-color: #dc3545;
    }
    .no-selection-text {
        color: #dc3545;
    }
    .search-item:hover {
        background-color: #ffffff !important;
    }
</style>
